export default "__VITE_ASSET__Cxvt1oqS__"